import { useTranslation } from 'react-i18next';
import { INDUSTRY_OPTIONS } from '@common/constants/data';

export const useIndustrySelector = () => {
  const { t } = useTranslation();
  const industrySelectorOptions = INDUSTRY_OPTIONS(t);

  return { industrySelectorOptions };
};
